<template>
  <div class="app-main-inner">
    <div class="section" style="width: 100%;margin-top: 2px">
      <span class="title">{{ $t('SeaExport.CustomsDeclarationInfo') }}</span>
      <div style="display: flex;">
        <div style="flex: 1;">
          <el-form v-if="!isSalesForSzfs" :disabled="readonly" label-width="50px" label-position="left">
            <el-form-item :label="$t('SeaExport.CustomsBroker')">
              <cargo-advance-select
                no="customsBroker"
                :select-type="selectTypeNames.basic_data_Company"
                :data-filter-function="customsBrokerFilter"
                filterable
                style="width:200px"
                :default-value="job.customsBroker||''"
                :method-params="{customsBroker:true,companyLob:'seaExport',active:true}"
                @parentCallBack="p=>{job.customsBroker=p.value||0}"
              />
            </el-form-item>
          </el-form>
          <el-form :disabled="readonly" label-width="50px" label-position="left">
            <el-form-item :label="$t('SeaExport.Remarks')" class="custom">
              <el-input
                v-model="job.customsRemarks"
                no="customsRemarks"
                type="textarea"
                :rows="5"
                style="width:200px"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.Remarks'),job.customsRemarks,val=>{job.customsRemarks=val})"
              />
            </el-form-item>
          </el-form>
        </div>
        <div style="flex: 1; margin-left: 10px;">
          <el-form :disabled="readonly" label-width="90px" label-position="left">
            <el-form-item :label="$t('SeaExport.AdvancePayment')">
              <el-select
                v-model="advancePaymentValue"
                style="width:200px"
                no="advancePayment"
                @change="handleAdvancePaymentChange"
              >
                <el-option
                  v-for="item in SystemConstants.YESORNO_STATES"
                  :key="item.code"
                  :label="$store.getters.language === 'zh'?item.chineseName:item.englishName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
          </el-form>
          <el-form :disabled="readonly" label-width="90px" label-position="left">
            <el-form-item :label="$t('SeaExport.TaxRemarks')" class="custom">
              <el-input
                v-model="job.taxRemarks"
                no="taxRemarks"
                type="textarea"
                :rows="5"
                style="width:200px"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.TaxRemarks'),job.taxRemarks,val=>{job.taxRemarks=val})"
              />
            </el-form-item>
          </el-form>
        </div>
        <div style="flex: 1; margin-left: 10px;">
          <el-form :disabled="readonly" label-width="90px">
            <el-form-item :label="$t('SeaExport.CustomsDutyAmount')">
              <auto-number-input
                v-model="job.customsDutyAmount"
                no="customsDutyAmount"
                style="width: 200px"
                :precision="2"
                :disabled="readonly"
                :min="0"
              />
            </el-form-item>
          </el-form>
        </div>
        <div style="flex: 1; margin-left: 10px;">
          <el-form :disabled="readonly">
            <el-form-item :label="$t('SeaExport.VatAmount')">
              <auto-number-input
                v-model="job.vatAmount"
                no="vatAmount"
                style="width: 200px"
                :precision="2"
                :disabled="readonly"
                :min="0"
              />
            </el-form-item>
          </el-form>
        </div>
        <div style="flex: 1; margin-left: 10px;">
          <el-form :disabled="readonly">
            <el-form-item :label="$t('SeaExport.PaymentTime')">
              <el-date-picker
                v-model="job.paymentTime"
                no="paymentTime"
                :disabled="readonly"
                type="date"
                style="width: 200px"
                clearable
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div class="operations">
      <div v-show="cooperateEdit" class="triggers">
        <div>
          <el-button no="NewCustomsDeclaration" type="primary" :disabled="!btnEnable || (isEdit && openXhqCustomsAll)" @click="addCustInfoHandler">{{ $t('SeaExport.NewCustomsDeclaration') }}</el-button>
          <el-button no="EditCustomsDeclaration" type="primary" :disabled="!btnEnable || (isEdit && (openXhqCustoms || openXhqCustomsAll))" @click="editCustInfoHandler">{{ $t('SeaExport.EditCustomsDeclaration') }}</el-button>
          <el-button v-show="!openXhqCustomsAll || openMeiHuaCustom" no="DeleteCustomsDeclaration" type="danger" :disabled="!btnEnable" @click="delCustInfoHandler">{{ $t('SeaExport.DeleteCustomsDeclaration') }}</el-button>
          <el-button v-show="openXhqCustomsAll && !openMeiHuaCustom" v-permission="['button_customs_forceDelete']" no="xhqDeleteCustomsDeclaration" type="danger" :disabled="!btnEnable || isEdit" @click="xhqDelCustInfoHandler">{{ $t('SeaExport.DeleteCustomsDeclaration') }}</el-button>
          <el-button v-show="openXhqCustomsAll && !openMeiHuaCustom" no="xhqCustomsUnFrozen" type="primary" :disabled="!btnEnable || isEdit" @click="toXhqCustomsUnFrozenHandler">{{ $t('CargoMsg.UnFrozen') }}</el-button>
          <el-button v-show="(openXhqCustoms || openXhqCustomsAll) && !openMeiHuaCustom" no="GetCustomsFile" type="primary" :disabled="!btnEnable || !(job.jobState === 0) || isEdit" @click="getCustomsFile">{{ $t('SeaExport.GetFiles') }}</el-button>
          <el-button v-show="closeXhqCustoms && !openOujianCustoms && job.lob === 'SE'" no="GetOcrFile" type="primary" :disabled="job.jobState !== 0 || isEdit || !$checkPermission(['button_customs_IdentifyTheCustoms'])" @click="getOcrFileHandler">{{ $t('CargoMsg.Cargo_IdentifyTheCustomsDeclaration') }}</el-button>
          <el-button v-show="closeXhqCustoms && !openOujianCustoms && job.lob === 'SE'" no="RefreshOcrFile" type="primary" :disabled="job.jobState !== 0 || isEdit" @click="loadList">{{ $t('CargoMsg.Cargo_RefreshCustomsDeclaration') }}</el-button>
        </div>
      </div>
    </div>
    <div class="section" style="flex: 1;margin-top: 5px">
      <cargo-ag-grid
        :grid-options="gridOptions"
        :grid-params.sync="gridParams"
        :config-module="closeXhqCustoms ? '20240830' : '20240831'"
        :column-defs="closeXhqCustoms ? columnDefs : xhqColumnDefs"
        :row-data="rowData"
        style="width:100%;height:100%"
        @gridReady="params=>gridApi=params.api"
      />
    </div>
    <!-- 编辑弹框 -->
    <customs-info-dialog ref="customsInfoDialog" :customs-infos="rowData" :slave-customs-declaration-enable="slaveCustomsDeclarationEnable" :visible.sync="editDialog.visible" :is-sales-for-szfs="isSalesForSzfs" :selected-customs-info="selectedCustomsInfo" :job="job" @successHandler="successHandler" @loadList="loadList" />
    <!-- 编辑弹框 欧坚 -->
    <customs-info-dialog-ouj ref="customsInfoDialogOuj" :visible.sync="editOujianDialog.visible" :selected-customs-info="editOujianDialog.customsInfo" :job="editOujianDialog.job" @successHandler="successHandler" @close="editOujianDialog.visible=false" />
    <!-- 海关回执弹窗 -->
    <customs-info-interact-res-dialog ref="customsInfoInteractResDialog" :visible.sync="interactResDialog.visible" :customs-id="interactResDialog.customsId" />
    <!-- 回执文件弹窗 -->
    <file-history-dialog ref="fileHistoryDialog" :visible.sync="fileHistoryDialog.visible" :customs-id="fileHistoryDialog.customsId" />
    <information-comparison-dialog ref="informationComparisonDialog" :visible.sync="informationComparisonDialog.visible" :data="informationComparisonDialog.data" />
    <!-- 海关回执记录弹窗 -->
    <customs-receipt-record-dialog ref="customsReceiptRecordDialog" :visible.sync="customsReceiptRecordDialog.visible" :selected-customs-info="customsReceiptRecordDialog.customsInfo" />
    <!-- 验证规则弹窗 -->
    <checking-window
      v-if="checkingWindow.visible"
      :visible.sync="checkingWindow.visible"
      :lob="job.lob"
      :job="job"
      :check-node="checkingWindow.checkNode"
      :call-back="checkingWindow.callBack"
      :call-back2="checkingWindow.callBack2"
    />
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      no="advanceText"
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-rich-textarea
        v-model="advanceTextDialog.value"
        :disabled="readonly"
        :warning-count="-1"
        :text-chars="0"
        :auto-uppercase="advanceTextDialog.autoUppercase"
        style="height: 320px;"
      />
      <span slot="footer">
        <el-button
          v-show="isEdit"
          no="confirm"
          type="primary"
          @click="finishAdvanceText"
        >{{ $t('common.btn.confirm') }}</el-button>
        <el-button no="close" @click="advanceTextDialog.visible=false">{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>

    <!--   iChannel: 3 报关, pageSource: 'customsInfo' 报关页面 -->
    <drop-uploader
      v-if="closeXhqCustoms && job.lob === 'SE'"
      ref="dropUploader"
      :action="URL.AIdiscern.importAndAnalyseFile"
      :upload-params="{ source: INTELLIGENT_DOCUMENT_SOURCE_9.code, iChannel: 3, jobUuid: job.uuid, pageSource: 'customsInfo', officeId: $store.getters.currentOfficeId }"
      :accept="['pdf','xls','xlsx','doc','docx','jpg','gif','png','tif', 'msword', 'ms-excel', 'jpeg', 'rtf']"
      :file-format="fileFormat"
      :multiple="false"
      :open-drag="false"
      :bs-open="bsOpen"
      @upload-result="uploadResultHandler"
    />
  </div>
</template>

<script>

import { cacheName, cache } from '@/utils/cacheManager'
import customsInfoInteractResDialog from '@/components/Cargo/Job/booking/tabs/ouJian/customsInfoInteractResDialog'
import fileHistoryDialog from '@/components/Cargo/Job/booking/tabs/ouJian/fileHistoryDialog'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import DropUploader from '@/components/Cargo/Common/DropUploader'
import URL from '@/api/urlTranslator'
import AnalysisDuration from '../../AnalysisDuration'
import {
  customsList,
  customsInfoDeleteAll,
  getCustomsFiles,
  xhqCustomsList,
  xhqCustomsUnFrozen, customsSave
} from '@/api/seaExport/customsInfo'
import { File } from '@/class/model/booking/File'
import CustomsInfoDialog from '@/components/Cargo/Job/customsInfoDialog'
import * as FileType from '@/class/cargo/model/parameters/FileType'
import { queryFileByOriginFileId, saveFile } from '@/api/seaExport/file'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getObjectByCache } from '@/utils/basicDataCache'
import { Job } from '@/class/model/booking/Job'
import StrUtils from '@/utils/StrUtils'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { AirImportJob } from '@/class/model/booking/AirImportJob'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import customsInfoDialogOuj from '@/components/Cargo/Job/booking/tabs/ouJian/customsInfoDialogOuj'
import SenderAndReceiver from '@/mixin/SenderAndReceiver'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import InformationComparisonDialog from '@/components/Cargo/Job/informationComparisonDialog.vue'
import * as XhqCustomState from '@/class/cargo/model/parameters/XhqCustomState'
import * as XhqCustomsUnfrozenState from '@/class/cargo/model/parameters/XhqCustomsUnfrozenState'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import customsReceiptRecordDialog from '@/components/Cargo/Job/booking/tabs/customsReceiptRecordDialog'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import CheckingWindow from '@/components/Cargo/Job/CheckingManager/CheckingWindow'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { checkBsItemOpened } from '@/api/booking/job'
import * as ContainerLoadType from '@/class/cargo/model/parameters/ContainerLoadType'
import { CustomsInfo } from '@/class/model/booking/CustomsInfo'
import { INTELLIGENT_DOCUMENT_SOURCE_9 } from '@/class/cargo/model/parameters/SystemConstants'
import { getStateByCode } from '@/class/cargo/model/parameters/CommonState'
import { poItems } from '@/api/seaExport/poItems'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput.vue'

export default {
  name: 'TabCustomsInfo',
  components: { AutoNumberInput, InformationComparisonDialog, DropUploader, customsInfoInteractResDialog, fileHistoryDialog, CustomsInfoDialog, cargoAdvanceSelect, cargoCompanySelect, customsInfoDialogOuj, cargoRichTextarea, customsReceiptRecordDialog, CheckingWindow },
  mixins: [SenderAndReceiver],
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    },
    slaveCustomsDeclarationEnable: { // 【小票】关单信息 是否可用
      type: Boolean,
      default: false
    },
    isSalesForSzfs: { type: Boolean, default: false } // 深圳丰收销售专用
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      form: {
        uuid: ''
      },
      bsOpen: false,
      URL,
      INTELLIGENT_DOCUMENT_SOURCE_9,
      fileFormat: '.pdf,.xls,.xlsx,.doc,.docx,.jpg,.gif,.png,.tif',
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          this.onCellFocused(event)
        },
        onRowClicked: this.onRowClicked,
        onCellClicked: this.showInteractRes
      },
      xhqColumnDefs: [
        {
          headerName: '',
          field: '',
          width: 65,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('SeaExport.SoNo'),
          field: 'soNo',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CustomsBroker'),
          field: 'customsBroker',
          width: 120,
          valueFormatter: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_9') : ''
          }
        },
        {
          headerName: this.$t('CargoMsg.CustomsDeclareTime'),
          field: 'declareTime',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.CustomsReceiptFile'),
          field: 'fileHistory',
          width: 120,
          cellRenderer: (params) => {
            return '<a style="color: #1605FB;text-decoration:underline">' + this.$t('SeaExport.ViewFile') + '</a>'
          }
        },
        {
          headerName: this.$t('SeaExport.UpdateTime'),
          field: 'dateModified',
          width: 140,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.NoticeBgh'),
          field: 'noticeBgh',
          width: 120,
          cellRenderer: (params) => {
            return params.value ? 'Y' : 'N'
          }
        },
        {
          headerName: this.$t('CargoMsg.InformationComparison'),
          field: 'informationComparison',
          width: 120,
          cellRenderer: (params) => {
            if (!params.data.ifXhqCustomsDataReceived) {
              return ''
            }
            if ((params.data.localQuantity === params.data.customsQuantity) && (params.data.localWeight === params.data.customsWeight)) {
              return this.$t('Message.Agreement')
            }
            return '<a style="color: #1605FB;text-decoration:underline">' + this.$t('CargoMsg.Diff') + '</a>'
          }
        },
        {
          headerName: this.$t('SeaExport.Remarks'),
          field: 'remarks',
          width: 120
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CustomsDeclarationStatus'),
          field: 'xhqCustomState',
          width: 120,
          cellRenderer: (params) => {
            if (params.value === XhqCustomState.NOT_SENT.code || params.value === XhqCustomState.WITHDRAWN.code) {
              return this.$t('CargoMsg.NotSendingCustomerFile')
            } else if (params.value === XhqCustomState.SENT.code) {
              return this.$t('CargoMsg.CustomerFileHasBeenSent')
            } else if (params.value === XhqCustomState.SENT_LCL_TASK.code) {
              return this.$t('CargoMsg.LCLTaskSent')
            }
          }
        },
        {
          headerName: this.$t('CargoMsg.CustomsUnFrozen'),
          field: 'customsUnfrozenState',
          width: 120,
          cellRenderer: (params) => {
            if (params.value === XhqCustomsUnfrozenState.FROZEN.code) {
              return this.$t('CargoMsg.NotUnfreeze')
            } else if (params.value === XhqCustomsUnfrozenState.UN_FROZEN.code) {
              return this.$t('CargoMsg.Unfreeze')
            } else {
              return this.$t('CargoMsg.unfrozenOffline')
            }
          }
        },
        {
          headerName: this.$t('SeaExport.CustomsStatus'),
          field: 'customsStatus',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.columnLabelFunc(SystemConstants.CUSTOMS_STATUS, params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.CustomsBrokerStatus'),
          field: 'customsBrokerStatus',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.columnLabelFunc(SystemConstants.CUSTOMS_BROKER_STATUS, params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.CustomsReceiptRecord'),
          field: 'version',
          width: 150,
          cellRenderer: (params) => {
            return '<a style="color: #1605FB;text-decoration:underline">' + this.$t('SeaExport.View') + '</a>'
          }
        }
      ],
      rowData: [],
      gridApi: null,
      editDialog: {
        visible: false
      },
      editOujianDialog: {
        visible: false,
        job: {},
        customsInfo: {}
      },
      interactResDialog: {
        visible: false,
        customsId: ''
      },
      fileHistoryDialog: {
        visible: false,
        customsId: ''
      },
      customsReceiptRecordDialog: {
        visible: false,
        customsInfo: {}
      },
      currentUser: {},
      job: new Job().fillDefaultValue().getData(),
      isShowUploadFile: false,
      selectedCustomsInfo: {},
      isNew: false,
      lockButton: false,
      btnEnable: false,
      xinHaoQiApi: 0,
      informationComparisonDialog: {
        visible: false,
        data: {}
      },
      checkingWindow: {
        visible: false,
        checkNode: 0,
        callBack: null,
        callBack2: null
      },
      openMeiHuaCustom: false
    }
  },
  computed: {
    SystemConstants() {
      return SystemConstants
    },
    readonly() {
      if (!this.cooperateEdit) return true
      return this.action === 'look'
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look'
    },
    openOujianCustoms() {
      return Number(cache.config.get('openOujianCustoms')) === 1
    },
    openOujianAndSeSiAeAi() {
      return this.openOujianCustoms && (this.job.lob === 'SE' || this.job.lob === 'SI' || this.job.lob === 'AE' || this.job.lob === 'AI')
      // return this.openOujianCustoms && (this.job.lob === 'SE' || this.job.lob === 'SI')
    },
    closeXhqCustoms() { // 关闭信号旗报关参数
      return this.xinHaoQiApi === 0 && !this.openMeiHuaCustom
    },
    openXhqCustoms() { // 信号旗参数等于1，仅接收文件
      return this.xinHaoQiApi === 1
    },
    openXhqCustomsAll() { // 信号旗参数等于2，推送信号旗报关单，同时接收回传文件 (完整模式)
      return this.xinHaoQiApi === 2
    },
    advancePaymentValue: {
      get() {
        return this.job.advancePayment ? 1 : 0
      }
    },
    columnDefs() {
      const list = [
        {
          headerName: '',
          field: '',
          width: 65,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('SeaExport.BlNo'),
          field: 'mbl',
          width: 120,
          hide: !this.isShowUploadFile
        },
        {
          headerName: this.$t('SeaExport.CustomsCode'),
          field: 'tenDigitCode',
          width: 200
        },
        {
          headerName: this.$t('SeaExport.SoNo'),
          field: 'soNo',
          width: 200
        },
        {
          headerName: this.$t('SeaExport.DateOfCustomsDeclaration'),
          field: 'customsDate',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.CustomsReceiptState'),
          field: 'interactRes',
          width: 120,
          cellRenderer: (params) => {
            return '<a style="color: #1605FB;text-decoration:underline">' + params.value + '</a>'
          }
        },
        {
          headerName: this.$t('SeaExport.CustomsReceiptFile'),
          field: 'fileHistory',
          width: 120,
          cellRenderer: (params) => {
            return '<a style="color: #1605FB;text-decoration:underline">' + this.$t('SeaExport.ViewFile') + '</a>'
          }
        },
        {
          headerName: this.$t('SeaExport.UpdateTime'),
          field: 'dateModified',
          width: 140,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.StatusOfCustomsDeclaration'),
          field: 'declareCustomsState',
          width: 120,
          cellRenderer: (params) => {
            return this.customsStateLabFun(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.CommodityInspectionOrNot'),
          field: 'commodityInspection',
          width: 120,
          cellRenderer: (params) => {
            return this.commodityLabFun(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.CustomsInspectionOrNot'),
          field: 'spotInspection',
          width: 120,
          cellRenderer: (params) => {
            return this.commodityLabFun(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.CustomsNo'),
          field: 'customsNo',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.Remarks'),
          field: 'remarks',
          width: 120
        }
      ]
      if (!this.openOujianCustoms) {
        list.push({
          headerName: this.$t('CargoMsg.Cargo_CustomsDeclarationNo'),
          field: 'customsDeclarationNo',
          width: 120
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AnalysisStatus'),
          colId: 'analysisStatus',
          field: 'analysisStatus',
          cellRendererFramework: AnalysisDuration,
          filterValueGetter: (params) => {
            const s = getStateByCode(SystemConstants.ANALYSIS_STATUS_LIST, params.value)
            if (s) {
              return this.$store.getters.language === 'zh' ? s.chineseName : s.englishName
            } else {
              return ''
            }
          },
          width: 240
        },
        {
          headerName: this.$t('SeaExport.Quantity2'),
          field: 'quantity',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.ExchangeRate'),
          field: 'rate',
          width: 120
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SystemFee'),
          field: 'systemFee',
          width: 120
        },
        {
          headerName: this.$t('CargoMsg.Cargo_InsurancePremium'),
          field: 'insurancePremium',
          width: 120
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ProcessingFee'),
          field: 'processingFee',
          width: 120
        },
        {
          headerName: this.$t('CargoMsg.Cargo_FOBValue'),
          field: 'freeOnBoard',
          width: 120
        })
      }
      if (!this.isSalesForSzfs) {
        list.push({
          headerName: this.$t('SeaExport.OperatingCompany'),
          field: 'companyCname',
          width: 200
        })
      }
      return list
    }
  },
  created() {
  },
  mounted() {
    this.$emit('mounted')
  },
  methods: {
    async onShow(row, isRefresh) {
      if (!isRefresh) {
        return
      }

      await cache.load(cacheName.USER, cacheName.CONFIG)
      this.xinHaoQiApi = Number(cache.config.get('xinHaoQiApi'))
      this.openMeiHuaCustom = Number(cache.config.get('openMeiHuaCustom')) === 1
      this.currentUser = cache.user
      this.job = row
      this.queryBs()

      if (row.uuid) {
        this.display()
        // 加载列表数据
        this.loadList()
        this.informationComparisonDialog.visible = false // 切换行数据时，关闭对比弹窗
      }
    },
    queryBs() {
      // 查询计费系统是否开通托书
      checkBsItemOpened(SystemConstants.TYPE_CUSTOMS_ANALYSIS).then(res => {
        if (!res.data || res.data === -1) {
          this.bsOpen = false
        } else {
          this.bsOpen = true
        }
      })
    },
    display() {
      this.btnEnable = false
      if (!StrUtils.isEmpty(this.job.uuid)) {
        // todo printHblZbLock job上的此属性暂未赋值
        // this.lockButton = this.job.printHblZbLock
        this.btnEnable = true
      }
      //  enabled="{!lockButton && job&&  !job.isNewInstance()}"
    },
    fillMode() {
      // todo 报关空运相关的
      /* if(job is AirExportJob)
      {
        AirExportJob(job).actualFlight = txtActualFlight.text;
        job.ATD = dfDateATD.selectedDate;
        AirExportJob(job).onwardJourney = txtOnwardJourney.text;
      }
      JobUtils.synCustomsBroker(job,job.customsBroker,0);*/
    },
    getSubmitData() {
      this.validateForm(this.job)
      this.fillMode()
      const job = { ...this.job }
      return {
        job
      }
    },
    validateForm(form) {
      // UI自定义中用到
    },
    async loadList() {
      await this.doLoadList()
      this.refreshCustomsAnalysis(1)
    },
    // 处理 select 的 change 事件
    handleAdvancePaymentChange(value) {
      this.job.advancePayment = value === 1
    },
    async doLoadList() {
      if (!this.closeXhqCustoms) {
        await xhqCustomsList(this.job.uuid).then(res => {
          this.rowData = res.data
        })
      } else {
        await customsList(this.job.uuid).then(res => {
          this.rowData = res.data
        })
      }
      this.selectedCustomsInfo = {}
      if (this.gridApi) {
        this.gridApi.clearFocusedCell()
      }
    },
    customsStateLabFun(declareCustomsState) {
      if (declareCustomsState === 1) {
        return this.$t('SeaExport.Recorded')
      } else if (declareCustomsState === 2) {
        return this.$t('SeaExport.ListPulled')
      } else if (declareCustomsState === 3) {
        return this.$t('SeaExport.AtReception')
      } else if (declareCustomsState === 4) {
        return this.$t('SeaExport.CustomsDeclared')
      } else if (declareCustomsState === 5) {
        return this.$t('SeaExport.Undeclared')
      } else if (declareCustomsState === 6) {
        return this.$t('SeaExport.CustomsExamination')
      } else if (declareCustomsState === 7) {
        return this.$t('SeaExport.InspectionExamination')
      } else if (declareCustomsState === 8) {
        return this.$t('SeaExport.ExamedWithoutReleasing')
      } else if (declareCustomsState === 9) {
        return this.$t('SeaExport.AmendDeclaration')
      } else if (declareCustomsState === 10) {
        return this.$t('SeaExport.NotifyToDeclare')
      } else if (declareCustomsState === 11) {
        return this.$t('SeaExport.CustomsHasCheck')
      } else if (declareCustomsState === 12) {
        return this.$t('SeaExport.CustomsExamed')
      } else if (declareCustomsState === 13) {
        return this.$t('SeaExport.CustomsOneRelease')
      } else if (declareCustomsState === 14) {
        return this.$t('SeaExport.CustomsRelease2')
      } else if (declareCustomsState === 15) {
        return this.$t('SeaExport.hasBeanSend')
      } else if (declareCustomsState === 16) {
        return this.$t('SeaExport.notSend')
      } else if (declareCustomsState === 17) {
        const value = this.$t('SeaExport.sendFailed')
        return `<span style="color: red">${value}</span>`
      } else if (declareCustomsState === 18) {
        return this.$t('SeaExport.SelfDeclaration')
      }
      return this.$t('SeaExport.UnknownState')
    },
    commodityLabFun(commodityInspection) {
      const val = Boolean(commodityInspection)
      if (val) {
        return this.$t('Message.Yes')
      }
      return this.$t('Message.No')
    },
    // 新增报关单
    addCustInfoHandler() {
      const customsInfo = {}
      customsInfo.mbl = this.job.mbl
      customsInfo.customsDate = new Date()
      customsInfo.jobUuid = this.job.uuid
      if (this.openOujianAndSeSiAeAi) {
        customsInfo.lob = this.job.lob
        customsInfo.declareCustomsState = 16
        customsInfo.portDistrict = this.job.portDistrict
      }
      this.isNew = true
      this.popUpCustomInfoWindow(customsInfo)
    },
    popUpCustomInfoWindow(customsInfo) {
      if (this.openOujianAndSeSiAeAi) {
        this.editOujianDialog.saveCallBack = this.successHandler
        const customsInfoDialogOuj = this.$refs.customsInfoDialogOuj
        customsInfoDialogOuj.isSe = false
        customsInfoDialogOuj.isSi = false
        customsInfoDialogOuj.isAe = false
        customsInfoDialogOuj.isAi = false
        customsInfoDialogOuj.isRe = false
        customsInfoDialogOuj.isLcl = false
        let seaImportJob
        switch (this.job.lob) {
          case 'SE':
            customsInfoDialogOuj.isSe = true
            break
          case 'SI':
            customsInfoDialogOuj.isSi = true
            seaImportJob = this.job
            if (seaImportJob.containerLoadType === 'LCL' || seaImportJob.containerLoadType === 'ECL') {
              customsInfoDialogOuj.isLcl = true
            }
            break
          case 'AE':
            customsInfoDialogOuj.isAe = true
            break
          case 'AI':
            customsInfoDialogOuj.isAi = true
            break
          case 'RE':
          case 'RI':
            customsInfoDialogOuj.isRe = true
            break
        }
        customsInfoDialogOuj.isNew = this.isNew
        this.editOujianDialog.customsInfo = customsInfo
        this.editOujianDialog.job = this.job
        this.editOujianDialog.visible = true
      } else {
        this.$nextTick(async() => {
          if (this.openXhqCustomsAll && this.isNew && this.rowData.length > 0) {
            // 验证规则
            const useCheckRule = Number(cache.config.get('useCheckRule')) === 1
            if (useCheckRule) {
              const hasCheckRule = await JobUtils.hasCheckRuleCondition(useCheckRule, CheckRuleConstants.NODE_SAVE_CUSTOMS.code, this.$store.getters.currentOfficeId)
              if (hasCheckRule) {
                this.checkingWindow.checkNode = CheckRuleConstants.NODE_SAVE_CUSTOMS.code
                this.checkingWindow.callBack = () => { this.addHandler() }
                this.checkingWindow.callBack2 = null
                this.checkingWindow.visible = true
              } else {
                this.addHandler()
              }
            } else {
              this.addHandler()
            }
          } else {
            this.addHandler()
          }
        })
      }
    },
    addHandler() {
      this.$refs.customsInfoDialog.onShow(this.isNew ? 'add' : 'edit', this.rowData)
      this.editDialog.visible = true
    },
    // 编辑报关单
    editCustInfoHandler() {
      const arr = Object.keys(this.selectedCustomsInfo)
      if (arr.length === 0) {
        this.$message.info(this.$t('Message.SelectCustomsInformation'))
        return
      }
      this.selectedCustomsInfo.portDistrict = this.job.portDistrict
      this.isNew = false
      this.popUpCustomInfoWindow(this.selectedCustomsInfo)
    },
    onRowClicked(event) {
      this.selectedCustomsInfo = event.data
    },
    onCellFocused(event) {
      if (this.gridOptions.api && event.column) {
        this.gridOptions.api.forEachNode(node => {
          if (node.rowIndex === event.rowIndex) {
            this.selectedCustomsInfo = node.data
          }
        })
      }
    },
    // 新增/编辑成功都走这里
    async successHandler(data) {
      if (this.isNew) {
        await this.addFile(data)
      }
      this.isNew = false
      await this.loadList()
    },
    // 设置 选中行
    setGridSelect(uuid) {
      const nodes = this.gridApi.getRenderedNodes()
      if (uuid) {
        for (const item of nodes) {
          if (uuid === item.data.uuid) {
            item.setSelected(true)
            this.selectedCustomsInfo = item.data
            break
          }
        }
      }
    },
    async addFile(customsInfo) {
      const file = new File().fillDefaultValue().getData()
      file.jobUuid = this.job.uuid
      file.jobNo = this.job.jobNo
      file.fileType = String(FileType.BGD_TYPE.code)
      file.tenDigitCode = customsInfo.tenDigitCode
      file.companyCname = customsInfo.companyCname
      file.customsBroker = customsInfo.customsBroker
      file.fileNo = customsInfo.soNo
      file.customsNo = customsInfo.customsNo
      const companyCache = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', this.job.customerId)
      file.receiveDate = new Date()
      file.receiveCompany = companyCache ? companyCache.chineseName : ''
      file.receivePerson = this.job.customerContact
      file.receiveTel = this.job.contactTelephone
      file.expressAddress = companyCache ? companyCache.address : ''
      file.state = 0
      file.branchId = this.job.opOffice
      file.inputBy = this.currentUser.userId
      file.inputByDep = this.$store.getters.currentDeptId
      file.inputDate = new Date()
      file.tax = false
      file.originFileId = customsInfo.uuid
      file.currentHolder = this.currentUser.userId
      file.remark = customsInfo.remarks
      await saveFile(file)
    },
    delCustInfoHandler() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.$confirm(this.$t('Message.SureDelete'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        const uuids = Array.from(rows, p => p.uuid)
        customsInfoDeleteAll(uuids).then(res => {
          this.loadList()
          this.refreshPoItems()
        })
      }).catch(() => {
      })
    },
    xhqDelCustInfoHandler() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      if (rows[0].xhqCustomState === XhqCustomState.SENT.code) {
        this.$confirm(this.$t('CargoMsg.ForceDeleteCustomsTips'), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          const uuids = Array.from(rows, p => p.uuid)
          customsInfoDeleteAll(uuids).then(res => {
            this.loadList()
            this.refreshPoItems()
          })
        }).catch(() => {
        })
      } else {
        this.$confirm(this.$t('Message.SureDelete'), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          const uuids = Array.from(rows, p => p.uuid)
          customsInfoDeleteAll(uuids).then(res => {
            this.loadList()
            this.refreshPoItems()
          })
        }).catch(() => {
        })
      }
    },
    async refreshPoItems() {
      // 刷新【关单信息】中【报关信息】
      if (!this.closeXhqCustoms && this.slaveCustomsDeclarationEnable) {
        this.job.poItems = await poItems({ jobUuid: this.job.uuid }).then(res => res.data)
      }
    },
    customsBrokerFilter(item, inputVal) {
      if (item.cmpIdx === inputVal) {
        return true
      }
      return item.customsBroker && item.seaExport && item.active
    },
    // 组装打印参数
    getPrintData() {
      const items = this.gridApi.getSelectedRows()
      if (!items || items.length <= 0) {
        this.$message.warning(this.$t('Message.SelectDeclarations'))
        return
      }
      const params = {}
      const uids = Array.from(items, p => p.uuid)
      params.CUSTOMS_INFO_UUID = uids.join(',')
      params.customsInfo_UUID_List = uids
      if (this.job === 'AI') {
        params.category = 'AICUSTOM'
        params.ctx = new AirImportJob(this.job)
      } else {
        params.category = 'CustomsList'
        params.ctx = new SeaExportJob(this.job)
      }
      // TemplateSelectorWin.getInstance().showThisWin(job,"CustomsList",ps,this);
      this.$logger.log('params', params)
      return params
    },
    // 查看回执历史
    showInteractRes(row) {
      console.log(row)
      if (row.colDef.field === 'interactRes' && row.data.interactRes) {
        this.interactResDialog.customsId = row.data.uuid
        this.interactResDialog.visible = true
      } else if (row.colDef.field === 'fileHistory') {
        queryFileByOriginFileId(row.data.uuid).then(res => {
          this.fileHistoryDialog.visible = true
          this.fileHistoryDialog.customsId = res.data.uuid
        })
      } else if (row.colDef.field === 'informationComparison') {
        if (this.rowData.length > 1) {
          this.$message.warning(this.$t('SeaExport.OnlySupportOneCustomsDeclaration'))
        }
        this.informationComparisonDialog.visible = true
        this.informationComparisonDialog.data = row.data
      } else if (row.colDef.field === 'version') {
        // 查看海关回执记录
        this.customsReceiptRecordDialog.visible = true
        this.customsReceiptRecordDialog.customsInfo = row.data
      }
    },
    getOcrFileHandler() {
      if (this.rowData) {
        for (const dd of this.rowData) {
          if (dd.analysisStatus === SystemConstants.ANALYSIS_STATUS_1.code) {
            this.$message.warning(this.$t('CargoMsg.Cargo_IdentifyTheCustomsTips'))
            return
          }
        }
      }
      // 计费系统校验
      checkBsItemOpened(SystemConstants.TYPE_CUSTOMS_ANALYSIS).then(res => {
        this.bsOpen = false
        if (!res.data) {
          // 未开通
          this.$message.warning(this.$t('CargoMsg.Cargo_CustomsActivatedTip'))
          return
        } else if (res.data <= 0) {
          // 余额不足
          this.$message.warning(this.$t('CargoMsg.Cargo_CustomsActivatedTip2'))
          return
        }
        this.bsOpen = true
        this.$refs.dropUploader.triggeFileSelectWindow()
      })
    },
    uploadResultHandler(fileId) {
      if (!fileId) {
        return
      }
      const customsInfo = new CustomsInfo().fillDefaultValue().getData()
      customsInfo.mbl = this.job.mbl
      customsInfo.customsDate = new Date()
      customsInfo.jobUuid = this.job.uuid
      customsInfo.declareCustomsType = ''
      customsInfo.lob = this.job.lob
      if (this.job.lob === 'AE') {
        customsInfo.declareCustomsState = 0
      }
      if (this.job.containerLoadType === ContainerLoadType.LCL_CARGO_TYPE.code ||
        this.job.containerLoadType === ContainerLoadType.BB_CARGO_TYPE.code ||
        this.job.containerLoadType === ContainerLoadType.BC_CARGO_TYPE.code) {
        customsInfo.verificationSheetRequired = false
      } else {
        customsInfo.verificationSheetRequired = true
      }
      customsInfo.xhqCustomState = XhqCustomState.NOT_SENT.code
      customsInfo.soNo = this.job.soNo
      customsInfo.customsFileId = fileId
      customsInfo.analysisStatus = SystemConstants.ANALYSIS_STATUS_1.code
      customsSave(customsInfo).then(res => {
        this.loadList()
      })
    },
    // 这里请求后端获取解析结果
    refreshCustomsAnalysis(i) {
      setTimeout(() => {
        if (i > 10) {
          return
        }
        if (this.rowData && this.rowData.length > 0) {
          const pendingParsing = this.rowData.filter(e => e.analysisStatus === SystemConstants.ANALYSIS_STATUS_1.code)
          if (pendingParsing && pendingParsing.length > 0) {
            this.doLoadList()
            this.refreshCustomsAnalysis(i++)
          }
        }
      }, i === 1 ? 10000 : 5000)
    },
    async getCustomsFile() {
      let orderOutNo
      if (this.rowData.length === 1) {
        orderOutNo = this.rowData[0].cbaNumber
      } else if (this.rowData.length > 1) {
        const rows = this.gridApi.getSelectedRows()
        if (rows.length === 0) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        } else if (rows.length > 1) {
          this.$message.warning(this.$t('SeaExport.OnlySupportOneCustomsCommission'))
          return
        }
        orderOutNo = rows[0].cbaNumber
      } else {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      const params = {
        orderOutNo: orderOutNo,
        jobUuid: this.job.uuid,
        opOffice: this.job.opOffice
      }
      this.loading = getLoading()
      await getCustomsFiles(params).then(res => {
        if (res.data && res.data.length > 0) {
          this.$message.success(this.$t('Message.ObtainSuccessfully'))
        } else {
          this.$message.error(this.$t('Message.Failure'))
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    toXhqCustomsUnFrozenHandler() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      const orderOutNos = []
      for (const item of rows) {
        if (item.cbaNumber) {
          orderOutNos.push(item.cbaNumber)
        }
      }
      this.$confirm(this.$t('CargoMsg.NotifyCustomsUnfreeze'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => {
        this.xhqCustomsUnFrozenHandler(orderOutNos)
      }).catch(() => {
      })
    },
    xhqCustomsUnFrozenHandler(orderOutNos) {
      const operator = getObjectByCache(TYPE_NAMES.basic_data_User, 'userId', this.$store.getters.userId)
      const data = {
        orderOutNos: orderOutNos,
        phone: operator ? operator.cell : '',
        hdUserName: operator ? operator.chineseName : '',
        opOffice: this.job.opOffice,
        jobUuid: this.job.uuid
      }
      const loading = getLoading4Cxt(this)
      xhqCustomsUnFrozen(data).then(res => {
        if (res.data) {
          this.$message.warning(res.data)
        } else {
          this.$message.success(this.$t('SeaExport.SendSucceeded'))
        }
      }).finally(() => loading.close())
      // 调用查询，刷新一下状态
      this.loadList()
    }
  }
}
</script>

<style>
</style>
